<template>
  <div class="content col-md-10">
    <ppe-form 
      entityName="User"
      title="A. Votre compte" 
      title-field="{name}"
      sub-title="Informations individuelles"
      :schema="schema" 
      :endpoint="this.getApiUrl()"
      
      />
      <!-- :redirect="getRedirectUrl()" -->
      <!--  :readonly="true" -->
  </div>
</template>

<script>
import ppeBusiness from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
  methods: {
    getApiUrl() {
      return "/user/profile" + (this.$route.params.id?"?id="+this.$route.params.id:"")
    },
      
		getRedirectUrl() {
			return "/ppe_eu/home/"+this.$route.params.id
		},
  } ,

  data () {
    return {

			schema : [
				{
					card:"",
					body:[
						{name:"name",     label:"Votre prénom et nom complet",  type: "text",  validation: 'required', size:'medium'},
						{name:"phone",    label:"Votre téléphone mobile",       type: "text",  validation: 'required', size:'medium'},
						{name:"email",    label:"Votre email (sert de login)",  type: "email", validation: 'required', size:'medium'},
            {component:"div",   },
						//{name:"password",   label:"Mot de passe",            type: "password", validation: '', help:"(si vous souhaitez le changer)"},
						//{name:"password_confirm",  label:"Confirmez le mot de passe",type: "password", validation: ''},

            {name:"password",   label:"Mot de passe",        autocomplete:"new-password",    type: "password", help:"(si vous souhaitez le changer)",
                  validation: '^optional|min:6,length|matches:/[0-9]/', 
                  validationMessages: {matches: 'Le mot de passe nécessite au moins un chiffre.', min:'Le mot de passe doit faire au moins 6 caractères'} },
						{name:"password_confirm",  label:"Confirmez le mot de passe", type: "password", autocomplete:"new-password",  validation: 'optional|confirm'},
            
          ]
        },
				Utils.getAdminCard([
          {name:"isTempPassword", label:"L'utilisateur doit changer son mot de passe à la prochaine connexion", type:"checkbox", size:"large"},
          {name:"groups", label:"Droits utilisateurs", type:"checkboxtable", size:"medium",
							options:ppeBusiness.getGroupOptions()
						},
        ]),
      ]

    }
  }
}
</script>